<template>
    <v-card tile elevation="0">
        <v-card-text>
            <template v-for="ebookProduct, index in ebookProducts">
                <v-layout :key="`company` + index">
                    <v-flex xs12 sm2>ebook 업체</v-flex>
                    <v-flex xs12 sm10>
                        <v-select v-model="ebookProduct._ebookCompany" :disabled="!$hasScope(['root', 'admin'])" :items="ebookCompanies" item-text="name" item-value="_id" outlined hide-details dense />
                    </v-flex>
                </v-layout>
                <v-layout :key="index" class="mt-4">
                    <v-flex xs12 sm2>ebook URL</v-flex>
                    <v-flex xs12 sm10>
                        <v-text-field v-model="ebookProduct.ebookValue" :disabled="!$hasScope(['root', 'admin'])" outlined hide-details dense />
                    </v-flex>
                </v-layout>
            </template>
        </v-card-text>
    </v-card>
</template>

<script>
import api from "@/api";
export default {
    props: {
        value: { type: [Object, Array], default(){ return [] } },
        enabled: { type: Boolean, default: false },
        salePrice: { type: Number }
    },
    data() {
        return {
            ebookCompanies: [],
            ebookProducts: this.$props.value || [],
        };
    },
    mounted(){
        this.init();
    },
    methods: {
        async init(){
            let { ebookCompanies } = await api.console.user.ebookCompanies.gets();
            this.ebookCompanies = ebookCompanies;
        }
    },
    watch: {
        enabled(){
            if(this.enabled && !this.ebookProducts.length){
                this.ebookProducts.push({
                    type: "ebook",
                    _ebookCompany: this.ebookCompanies?.[0]?._id,
                    ebookName: "ebook",
                    ebookValue: "",
                    salePrice: this.salePrice,
                    stock: 1,
                    addPrice: 0
                });
            }
        },
        value(){
            this.ebookProducts = this.value || [];
        },
        ebookProducts: {
            deep: true,
            handler(){
                this.$emit("input", this.ebookProducts);
                this.$emit("update:_ebookCompany", this.ebookProducts?.[0]?._ebookCompany);
            }
        }
    }
}
</script>

<style>
.shop-ebookProducts .v-input.text-center input { text-align: center; }
</style>
